import MicIcon from '@mui/icons-material/Mic';
import { useTheme } from '@mui/material';

export const Mic = ({ size = 'large' }) => {
  const theme = useTheme();

  return (
    <MicIcon fontSize={size} sx={{ color: theme.palette.tertiary.main }} />
  );
};
